import { Create, ListButton, TopToolbar } from 'react-admin';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import ApplicationReasonForm from './ApplicationReasonForm';

const ApplicationReasonActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const ApplicationReasonCreate = (props: any) => {
  return (
    <Create actions={<ApplicationReasonActions {...props} />} {...props}>
      <ApplicationReasonForm />
    </Create>
  );
};

export default ApplicationReasonCreate;
